import React, { useRef } from 'react'
import { Link } from 'react-router-dom'

// css
import '../css/About.css';

const About = () => {
  const section1Ref = useRef();
  const section2Ref = useRef();
  const section3Ref = useRef();
  const section1Scroll = () => section1Ref.current.scrollIntoView({ behavior: 'smooth' });
  const section2Scroll = () => section2Ref.current.scrollIntoView({ behavior: 'smooth' });
  const section3Scroll = () => section3Ref.current.scrollIntoView({ behavior: 'smooth' });

    return (
        <>  
            <div className="blueCarbonWrapper">
              {/* nav */}
              <div className="blueCarbonNav">
                <ul>
                  <li>
                    <Link to="/home"><img src="./images/about/logo.png" /></Link>
                  </li>
                  <li className="right">
                    <ul>
                      <li>
                        <Link to="/about" onClick={section1Scroll}>블루카본</Link>
                      </li>
                      <li>
                        <Link to="/about" onClick={section2Scroll}>국내 블루카본 현황</Link>
                      </li>
                      <li>
                        <Link to="/about" onClick={section3Scroll}>전세계 블루카본 흡수원 현황</Link>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
              {/* //nav */}
              {/* section1 */}
              <div className="blueCarbonSection1" ref={section1Ref}>
                <div className="content">
                  <div className="left">
                    <div className="head">
                      <img src="./images/about/head_ico1.svg" />
                      <h2>염습지 . 잘피 . 비식생 갯벌</h2>
                      <h1>블루카본</h1>
                    </div>
                    <div className="text">
                      <p>
                        블루카본(Blue Carbon)은 해양을 의미하는 Blue와
                        탄소를 뜻하는 Carbon의 합성어로 해양생태계가
                        흡수하는 탄소이다.
                      </p>
                      <p>
                        해양생물의 광합성을 통해 흡수된 이산화탄소는
                        생장 및 물질대사 과정에서 퇴적물에 침적되는데
                        이러한 과정을 통해
                        <b>해양생태계에 저장되는 탄소</b>를
                        ‘블루카본’이라 한다.
                      </p>
                    </div>
                    <div className="divider" />
                    <div className="additionalInfo">
                      <h1>다른 형태의 탄소는 무엇이 있을까요?</h1>
                      <ul>
                        <li>
                          <h1>그린카본</h1>
                          <h2>육상 생태계</h2>
                          <p>산림생태계가 흡수하는 탄소</p>
                        </li>
                        <li>
                          <h1>블랙카본</h1>
                          <h2>화석 연료</h2>
                          <p>
                            화석연로 등에서 배출되어 지구온난화를
                            유발하는 탄소
                          </p>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="right">
                    <ul>
                      <li>
                        <div className="imgBox">
                          <img src="./images/about/photo1.jpg" />
                        </div>
                      </li>
                      <li>
                        <div className="imgBox">
                          <img src="./images/about/photo2.jpg" />
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              {/* //section1 */}
              {/* section2 */}
              <div className="blueCarbonSection2">
                <div className="content">
                  <div className="head">
                    <h1>해양은 어떻게 탄소를 저장할까?</h1>
                    <p>
                      탄소 저장은 대기 중의 탄소를 영구 또는 반영구적으로
                      격리하는 것이다. 해양은 전지구 탄소수지, 해수,
                      해양식물, 해양동물에 의해 탄소를 저장할 수 있다.
                    </p>
                  </div>
                  <ul>
                    <li>
                      <img src="./images/about/dot.svg" />
                      <h1>전지구 탄소수지</h1>
                      <p>
                        해양은 전 세계 연간 이산화탄소 배출량(399억
                        톤)의 23%를 흡수한다. 대표적인 블루카본 흡수원의
                        면적은 전체 해양의 0.5%에 불과하지만 흡수되는
                        탄소량은 해양 전체의 50-71%에 해당한다.
                      </p>
                    </li>
                    <li>
                      <img src="./images/about/dot.svg" />
                      <h1>해수</h1>
                      <p>
                        해수의 탄소는 용해도 펌프와 생물학적 펌프에
                        영향을 받는다. 용해도 펌프는 대기 중의
                        이산화탄소가 해수에 녹아서 유입되는 것이다.
                        생물학적 펌프는 광합성, 골격 형성과 같은
                        생물활동에 의해 이산화탄소가 고정되어 침전되는
                        것이다.
                      </p>
                    </li>
                  </ul>
                  <ul>
                    <li>
                      <img src="./images/about/dot.svg" />
                      <h1>해양식물</h1>
                      <p>
                        맹그로브 숲과 잘피, 염습지 그리고 저서미세조류가
                        많은 갯벌 등의 해양 서식지는 다양한 기작을 통해
                        탄소를 흡수한다.
                      </p>
                    </li>
                    <li>
                      <img src="./images/about/dot.svg" />
                      <h1>해양동물</h1>
                      <p>
                        해양동물 중 조개나 달팽이, 새우같은 동물은
                        탄산칼슘 골격을 형성하는 과정에서 탄소를
                        흡수한다.
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
              {/* //section2 */}
              {/* section3 */}
              <div className="blueCarbonSection3">
                <div className="content">
                  <div className="head">
                    <h1>블루카본 흡수원</h1>
                    <p>
                      탄소 저장은 대기 중의 탄소를 영구 또는 반영구적으로 격리하는 것이다. 해양은 전지구 탄소수지, 해수, 해양식물, 해양동물에 의해 탄소를 저장할 수 있다.
                    </p>
                  </div>
                  <ul>
                    <li>
                      <div className="imgBox">
                        <img src="./images/about/photo3.jpg" />
                      </div>
                      <div className="text">
                        <h1>염습지</h1>
                        <p>
                          염습지는 바닷물이 드나들어 염분이 많은 습지이다.
                          갈대와 칠면초 등 내염성 식물이 서식하는 갯벌이다.
                          식생지에서는 유기탄소
                          저장량이 비식생지에 비해서 높게 나타나
                          식생이 유기탄소 저장에 중요한 환경요인이라는
                          것을 알 수 있다.
                        </p>
                      </div>
                    </li>
                    <li>
                      <div className="imgBox">
                        <img src="./images/about/photo4.jpg" />
                      </div>
                      <div className="text">
                        <h1>잘피</h1>
                        <p>
                          잘피는 해수에 적응하여 연안 및 하구생태계에
                          분포하고 있는 속씨식물이다.
                          잘피생육지는연안이나 하구생태계에서 서식지
                          제공, 생태계 정화능력, 기후변화 완화 등
                          다양한 생태계서비스를 제공하여 매우 중요한
                          역할을 한다.
                        </p>
                        <p>
                          전 세계적으로 잘피생육지는 해양 표면적의 약
                          0.1%에 불과하지만, 해양에서 흡수·축적되는
                          탄소 양의 10-18%를 차지한다. 또한 잘피생육지
                          내 퇴적물에 축적된 유기탄소는 수백년에서
                          수천년까지 저장될 수 있어, 기후변화를
                          완화시키는데 중요한 역할을 한다.
                        </p>
                      </div>
                    </li>
                    <li>
                      <div className="imgBox">
                        <img src="./images/about/photo5.jpg" />
                      </div>
                      <div className="text">
                        <h1>비식생 갯벌</h1>
                        <p>
                          갯벌은 밀물시에는 바닷물로 덮여있고
                          썰물시에는 육지로 드러나는 모래와 펄로
                          이루어진 다양한 해양생물의 서식지이다.
                          갯벌은 오염정화와 자연재해 예방 능력이
                          탁월한 생태자원이기 때문에 갯벌면적의 증감은
                          건강한 해양생태계를 판단할 수 있는 중요한
                          지표가 된다.
                        </p>
                        <p>
                          비식생 갯벌에서 생태계를 구성하는 핵심
                          요소인 저서미세조류(microphytobenthos,
                          MPB)는 광합성을 하는 단세포성 식물이다.
                          우리나라 갯벌의 규조류는 늦겨울부터 봄철에
                          생명활동이 폭발적으로 증가하는데, 그
                          과정에서 대기와 해수의 이산화탄소를 많이
                          흡수하고, 오랫동안 지속되는 퇴적과정에서
                          탄소를 퇴적물 내에 격리시켜 반영구적으로
                          저장한다.
                        </p>
                      </div>
                    </li>
                  </ul>
                  <div className="soloContentBox">
                    <div className="fullWidthImgBox">
                      <img src="./images/about/photo6.jpg" />
                    </div>
                    <h1>해양생태계의 탄소저장 모식도</h1>
                  </div>
                </div>
              </div>
              {/* //section3 */}
              {/* section4 */}
              <div className="blueCarbonSection4" ref={section2Ref}>
                <div className="content">
                  {/* layout1 */}
                  <div className="layoutType1">
                    <div className="head">
                      <img src="./images/about/head_ico2.svg" />
                      <h2>대한민국의 블루카본 탄소 흡수 능력</h2>
                      <h1>국내 블루카본 현황</h1>
                    </div>
                    <div className="text">
                      <p>
                        국내 연안생태계에는 염습지, 잘피, 비식생갯벌이 분포하며, 연간 총 50만톤 이상의 온실가스를 흡수하는 것으로 추정된다. 비식생갯벌은 단위면적당(1㎢) 연간
                        이산화탄소
                        흡수량이 약 200톤으로
                        다른 블루카본 서식지에 비해 적지만, 갯벌이 넓게 분포하고 있어 국내 해양생태계에서 가장 많은 이산화탄소를 흡수한다.
                      </p>
                    </div>
                    <div className="dataContainer">
                      <h1>
                        블루카본 별 연간 탄소 흡수량
                      </h1>
                      <div className="imgBox">
                        <img src="./images/about/data_img_1.svg" className="blueCarbonPC" />
                        <img src="./images/about/data_img_1.svg" className="blueCarbonMobile" />
                      </div>
                    </div>
                  </div>
                  {/* //layout1 */}
                  {/* layout2 */}
                  <div className="layoutType2">
                    <div className="head">
                      <h1>
                        염습지
                      </h1>
                      <p>
                        염습지는 서해안과 남해안 갯벌의 상부 지역에 주로 분포한다. 2020년 Landsat 위성영상을 분석한 결과, 국내 염습지의 면적은 31.74 ㎢이고 전라남도의 갯벌
                        면적은 전체의
                        약 39%에 해당한다. 위성영상으로 산출한 1990~2020년 염습지 면적을 비교하면 1990년 17.68㎢에서 2020년 31.74㎢로 약 14㎢가 증가했다.
                      </p>
                    </div>
                    <div className="dataContainer">
                      <ul>
                        <li>
                          <h1>
                            전국 염습지 분포현황 (2020)
                          </h1>
                          <div className="dataBox">
                            {/* table */}
                            <div className="blueCarbonTable">
                              <ul>
                                <li>
                                  <div className="blueCarbonTableHead">
                                    인천광역시
                                  </div>
                                  <div className="blueCarbonTableData">
                                    <ul>
                                      <li>
                                        <h1>면적.</h1>
                                        <p>4.40㎢</p>
                                      </li>
                                      <li>
                                        <h1>비율.</h1>
                                        <p>13.86%</p>
                                      </li>
                                    </ul>
                                  </div>
                                </li>
                                <li>
                                  <div className="blueCarbonTableHead">
                                    경기도
                                  </div>
                                  <div className="blueCarbonTableData">
                                    <ul>
                                      <li>
                                        <h1>면적.</h1>
                                        <p>4.18㎢</p>
                                      </li>
                                      <li>
                                        <h1>비율.</h1>
                                        <p>13.17%</p>
                                      </li>
                                    </ul>
                                  </div>
                                </li>
                                <li>
                                  <div className="blueCarbonTableHead">
                                    충청남도
                                  </div>
                                  <div className="blueCarbonTableData">
                                    <ul>
                                      <li>
                                        <h1>면적.</h1>
                                        <p>4.92㎢</p>
                                      </li>
                                      <li>
                                        <h1>비율.</h1>
                                        <p>15.50%</p>
                                      </li>
                                    </ul>
                                  </div>
                                </li>
                                <li>
                                  <div className="blueCarbonTableHead">
                                    전라북도
                                  </div>
                                  <div className="blueCarbonTableData">
                                    <ul>
                                      <li>
                                        <h1>면적.</h1>
                                        <p>1.44㎢</p>
                                      </li>
                                      <li>
                                        <h1>비율.</h1>
                                        <p>4.54%</p>
                                      </li>
                                    </ul>
                                  </div>
                                </li>
                                <li>
                                  <div className="blueCarbonTableHead">
                                    전라남도
                                  </div>
                                  <div className="blueCarbonTableData">
                                    <ul>
                                      <li>
                                        <h1>면적.</h1>
                                        <p>12.50㎢</p>
                                      </li>
                                      <li>
                                        <h1>비율.</h1>
                                        <p>39.38%</p>
                                      </li>
                                    </ul>
                                  </div>
                                </li>
                                <li>
                                  <div className="blueCarbonTableHead">
                                    경상남도
                                  </div>
                                  <div className="blueCarbonTableData">
                                    <ul>
                                      <li>
                                        <h1>면적.</h1>
                                        <p>1.47㎢</p>
                                      </li>
                                      <li>
                                        <h1>비율.</h1>
                                        <p>4.63%</p>
                                      </li>
                                    </ul>
                                  </div>
                                </li>
                                <li>
                                  <div className="blueCarbonTableHead">
                                    부산광역시
                                  </div>
                                  <div className="blueCarbonTableData">
                                    <ul>
                                      <li>
                                        <h1>면적.</h1>
                                        <p>2.83㎢</p>
                                      </li>
                                      <li>
                                        <h1>비율.</h1>
                                        <p>8.92%</p>
                                      </li>
                                    </ul>
                                  </div>
                                </li>
                                <li>
                                  <div className="blueCarbonTableHead">
                                    합계
                                  </div>
                                  <div className="blueCarbonTableData">
                                    <ul>
                                      <li>
                                        <h1>면적.</h1>
                                        <p className="pointColor">31.74㎢</p>
                                      </li>
                                      <li>
                                        <h1>비율.</h1>
                                        <p className="pointColor">100%</p>
                                      </li>
                                    </ul>
                                  </div>
                                </li>
                              </ul>
                            </div>
                            {/* //table */}
                          </div>
                        </li>
                        <li>
                          <h1>
                            전국 염습지 분포 변화 추이
                          </h1>
                          <div className="dataBox">
                            <img src="./images/about/data_img_2.svg" />
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                  {/* //layout2 */}
                  {/* layout2 */}
                  <div className="layoutType2">
                    <div className="head">
                      <h1>
                        잘피
                      </h1>
                      <p>
                        잘피는 모래와 진흙으로 이루어진 부드러운 토양이나 바위에 붙어서 살아가며, 썰물 때 드러나는 갯벌에서 수심 약 25m 정도까지 분포하는 것으로 알려져 있다. 국내
                        연안에는 다양한 종류의
                        잘피가 서식하는데 가장 널리 분포하는 잘피종은 거머리말로 총 분포면적은 4,413.2ha이다.
                      </p>
                    </div>
                    <div className="dataContainer">
                      <ul>
                        <li>
                          <h1>
                            해역별 거머리말속 잘피 서식면적
                          </h1>
                          <div className="dataBox">
                            <img src="./images/about/data_img_3.svg" />
                          </div>
                        </li>
                        <li>
                          <h1>
                            거머리말속 잘피 종별 분포
                          </h1>
                          <div className="dataBox">
                            <img src="./images/about/data_img_4.svg" />
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                  {/* //layout2 */}
                  {/* layout2 */}
                  <div className="layoutType2 marginBottomNone">
                    <div className="head">
                      <h1>
                        비식생갯벌
                      </h1>
                      <p>
                        해양수산부가 발표한 2018년 전국 갯벌 면적은 2,482㎢로 2013년 2,487.2㎢보다 5.2㎢ 감소했다. 전체 갯벌면적에서 서해안이 차지하는 면적이 약
                        83.8%인 2,079.9㎢이며,
                        나머지는 남해안에 분포한다.
                      </p>
                    </div>
                    <div className="dataContainer">
                      <ul>
                        <li>
                          <h1>
                            갯벌면적의 변동 추이
                          </h1>
                          <div className="dataBox">
                            <img src="./images/about/data_img_5.svg" />
                          </div>
                        </li>
                        <li>
                          <h1>
                            우리나라 전국 갯벌 분포현황 (2018)
                          </h1>
                          <div className="dataBox">
                            {/* table */}
                            <div className="blueCarbonTable">
                              <ul>
                                <li>
                                  <div className="blueCarbonTableHead">
                                    인천광역시
                                  </div>
                                  <div className="blueCarbonTableData">
                                    <ul>
                                      <li>
                                        <h1>면적.</h1>
                                        <p>728.3㎢</p>
                                      </li>
                                      <li>
                                        <h1>비율.</h1>
                                        <p>29.3%</p>
                                      </li>
                                    </ul>
                                  </div>
                                </li>
                                <li>
                                  <div className="blueCarbonTableHead">
                                    경기도
                                  </div>
                                  <div className="blueCarbonTableData">
                                    <ul>
                                      <li>
                                        <h1>면적.</h1>
                                        <p>165.9㎢</p>
                                      </li>
                                      <li>
                                        <h1>비율.</h1>
                                        <p>6.8%</p>
                                      </li>
                                    </ul>
                                  </div>
                                </li>
                                <li>
                                  <div className="blueCarbonTableHead">
                                    충청남도
                                  </div>
                                  <div className="blueCarbonTableData">
                                    <ul>
                                      <li>
                                        <h1>면적.</h1>
                                        <p>338.9㎢</p>
                                      </li>
                                      <li>
                                        <h1>비율.</h1>
                                        <p>13.7%</p>
                                      </li>
                                    </ul>
                                  </div>
                                </li>
                                <li>
                                  <div className="blueCarbonTableHead">
                                    전라북도
                                  </div>
                                  <div className="blueCarbonTableData">
                                    <ul>
                                      <li>
                                        <h1>면적.</h1>
                                        <p>110.5㎢</p>
                                      </li>
                                      <li>
                                        <h1>비율.</h1>
                                        <p>4.4%</p>
                                      </li>
                                    </ul>
                                  </div>
                                </li>
                                <li>
                                  <div className="blueCarbonTableHead">
                                    전라남도
                                  </div>
                                  <div className="blueCarbonTableData">
                                    <ul>
                                      <li>
                                        <h1>면적.</h1>
                                        <p>1,053.7㎢</p>
                                      </li>
                                      <li>
                                        <h1>비율.</h1>
                                        <p>42.5%</p>
                                      </li>
                                    </ul>
                                  </div>
                                </li>
                                <li>
                                  <div className="blueCarbonTableHead">
                                    경상남도
                                  </div>
                                  <div className="blueCarbonTableData">
                                    <ul>
                                      <li>
                                        <h1>면적.</h1>
                                        <p>62.8㎢</p>
                                      </li>
                                      <li>
                                        <h1>비율.</h1>
                                        <p>2.5%</p>
                                      </li>
                                    </ul>
                                  </div>
                                </li>
                                <li>
                                  <div className="blueCarbonTableHead">
                                    부산광역시
                                  </div>
                                  <div className="blueCarbonTableData">
                                    <ul>
                                      <li>
                                        <h1>면적.</h1>
                                        <p>20.1㎢</p>
                                      </li>
                                      <li>
                                        <h1>비율.</h1>
                                        <p>0.8%</p>
                                      </li>
                                    </ul>
                                  </div>
                                </li>
                                <li>
                                  <div className="blueCarbonTableHead">
                                    합계
                                  </div>
                                  <div className="blueCarbonTableData">
                                    <ul>
                                      <li>
                                        <h1>면적.</h1>
                                        <p className="pointColor">2,482.0㎢</p>
                                      </li>
                                      <li>
                                        <h1>비율.</h1>
                                        <p className="pointColor">100%</p>
                                      </li>
                                    </ul>
                                  </div>
                                </li>
                              </ul>
                            </div>
                            {/* //table */}
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                  {/* //layout2 */}
                </div>
              </div>
              {/* //section4 */}
              {/* section5 */}
              <div className="blueCarbonSection5" ref={section3Ref}>
                <div className="content">
                  {/* layout1 */}
                  <div className="layoutType1">
                    <div className="head">
                      <img src="./images/about/head_ico3.svg" />
                      {/* <h2>전 세계 블루카본 생태계 분포</h2> */}
                      <h1>전 세계 블루카본 생태계 분포</h1>
                    </div>
                    {/* <div class="text">
                              <p>
                                  국내 연안생태계에는 염습지, 잘피, 비식생갯벌이 분포하며, 연간 총 50만톤 이상의 온실가스를 흡수하는 것으로 추정된다. 비식생갯벌은 단위면적당(1㎢) 연간
                                  이산화탄소
                                  흡수량이 약 200톤으로
                                  다른 블루카본 서식지에 비해 적지만, 갯벌이 넓게 분포하고 있어 국내 해양생태계에서 가장 많은 이산화탄소를 흡수한다.
                              </p>
                          </div>
                          <div class="soloContentBox">
                              <div class="fullWidthImgBox">
                                  <img src="./images/about/photo7.jpg"/>
                              </div>
                          </div> */}
                  </div>
                  {/* //layout1 */}
                  {/* layout2 */}
                  <div className="layoutType2">
                    <ul>
                      <li>
                        <div className="text">
                          <h1>염습지</h1>
                          <p>
                            염습지는 전 세계 해안선을 따라 분포하는데, 특히 온대와 북극 지역에 주로 우세하다.
                            큰 조차가 있는 지역에서 염습지가 넓게 분포하는 경향을 보인다. 전 세계 염습지
                            면적은 22,000~400,000㎢로 추정한다.
                          </p>
                        </div>
                        <div className="imgBox">
                          <img src="./images/about/photo8.jpg" />
                        </div>
                      </li>
                      <li className="type2">
                        <div className="dataContainer">
                          <ul>
                            <li>
                              <h1>
                                지역별 염습지 면적(2017)
                              </h1>
                              <div className="dataBox">
                                {/* table */}
                                <div className="blueCarbonTable">
                                  <ul>
                                    <li>
                                      <div className="blueCarbonTableHead">
                                        오세아니아
                                      </div>
                                      <div className="blueCarbonTableData">
                                        <ul>
                                          <li>
                                            <h1>면적.</h1>
                                            <p>13,456㎢</p>
                                          </li>
                                        </ul>
                                      </div>
                                    </li>
                                    <li>
                                      <div className="blueCarbonTableHead">
                                        러시아
                                      </div>
                                      <div className="blueCarbonTableData">
                                        <ul>
                                          <li>
                                            <h1>면적.</h1>
                                            <p>7,007㎢</p>
                                          </li>
                                        </ul>
                                      </div>
                                    </li>
                                    <li>
                                      <div className="blueCarbonTableHead">
                                        중국
                                      </div>
                                      <div className="blueCarbonTableData">
                                        <ul>
                                          <li>
                                            <h1>면적.</h1>
                                            <p>5,495㎢</p>
                                          </li>
                                        </ul>
                                      </div>
                                    </li>
                                    <li>
                                      <div className="blueCarbonTableHead">
                                        유럽
                                      </div>
                                      <div className="blueCarbonTableData">
                                        <ul>
                                          <li>
                                            <h1>면적.</h1>
                                            <p>4,512㎢</p>
                                          </li>
                                        </ul>
                                      </div>
                                    </li>
                                    <li>
                                      <div className="blueCarbonTableHead">
                                        남아메리카
                                      </div>
                                      <div className="blueCarbonTableData">
                                        <ul>
                                          <li>
                                            <h1>면적.</h1>
                                            <p>1,568㎢</p>
                                          </li>
                                        </ul>
                                      </div>
                                    </li>
                                    <li>
                                      <div className="blueCarbonTableHead">
                                        아프리카 및 중동
                                      </div>
                                      <div className="blueCarbonTableData">
                                        <ul>
                                          <li>
                                            <h1>면적.</h1>
                                            <p>168㎢</p>
                                          </li>
                                        </ul>
                                      </div>
                                    </li>
                                    <li>
                                      <div className="blueCarbonTableHead">
                                        대한민국
                                      </div>
                                      <div className="blueCarbonTableData">
                                        <ul>
                                          <li>
                                            <h1>면적.</h1>
                                            <p className="pointColor">32㎢</p>
                                          </li>
                                        </ul>
                                      </div>
                                    </li>
                                  </ul>
                                </div>
                                {/* //table */}
                              </div>
                            </li>
                          </ul>
                        </div>
                      </li>
                      <li className="divider" />
                      <li>
                        <div className="text">
                          <h1>맹그로브</h1>
                          <p>
                            맹그로브는 전 세계의 열대 및 아열대 해안과 하구에 서식한다. 맹그로브는 123개 국가에
                            넓게 분포하지만, 전 지구적 규모는 열대우림의 1% 이하로 분포범위는 적다.<br />
                            맹그로브의 총 면적은 1996년에 141,957㎢였으나 2016년에는 135,882㎢로 6,075㎢
                            (4.3%)가 감소했다. 국내에서 맹그로브의 서식은 보고된 바가 없다.
                          </p>
                        </div>
                        <div className="imgBox">
                          <img src="./images/about/photo9.jpg" />
                        </div>
                      </li>
                      <li className="type2">
                        <div className="dataContainer">
                          <ul>
                            <li>
                              <h1>
                                지역별 맹그로브 면적(2016)
                              </h1>
                              <div className="dataBox">
                                {/* table */}
                                <div className="blueCarbonTable">
                                  <ul>
                                    <li>
                                      <div className="blueCarbonTableHead">
                                        동남아시아
                                      </div>
                                      <div className="blueCarbonTableData">
                                        <ul>
                                          <li>
                                            <h1>면적.</h1>
                                            <p>43,767㎢</p>
                                          </li>
                                        </ul>
                                      </div>
                                    </li>
                                    <li>
                                      <div className="blueCarbonTableHead">
                                        북아메리카
                                      </div>
                                      <div className="blueCarbonTableData">
                                        <ul>
                                          <li>
                                            <h1>면적.</h1>
                                            <p>20,962㎢</p>
                                          </li>
                                        </ul>
                                      </div>
                                    </li>
                                    <li>
                                      <div className="blueCarbonTableHead">
                                        서부 및 중앙 아프리카
                                      </div>
                                      <div className="blueCarbonTableData">
                                        <ul>
                                          <li>
                                            <h1>면적.</h1>
                                            <p>19,767㎢</p>
                                          </li>
                                        </ul>
                                      </div>
                                    </li>
                                    <li>
                                      <div className="blueCarbonTableHead">
                                        남아메리카
                                      </div>
                                      <div className="blueCarbonTableData">
                                        <ul>
                                          <li>
                                            <h1>면적.</h1>
                                            <p>18,943㎢</p>
                                          </li>
                                        </ul>
                                      </div>
                                    </li>
                                    <li>
                                      <div className="blueCarbonTableHead">
                                        호주 및 뉴질랜드
                                      </div>
                                      <div className="blueCarbonTableData">
                                        <ul>
                                          <li>
                                            <h1>면적.</h1>
                                            <p>9,983㎢</p>
                                          </li>
                                        </ul>
                                      </div>
                                    </li>
                                    <li>
                                      <div className="blueCarbonTableHead">
                                        동아시아
                                      </div>
                                      <div className="blueCarbonTableData">
                                        <ul>
                                          <li>
                                            <h1>면적.</h1>
                                            <p>171㎢</p>
                                          </li>
                                        </ul>
                                      </div>
                                    </li>
                                    {/* <li>
                                                              <div class="blueCarbonTableHead">
                                                                  대한민국
                                                              </div>
                                                              <div class="blueCarbonTableData">
                                                                  <ul>
                                                                      <li>
                                                                          <h1>면적.</h1>
                                                                          <p class="pointColor">32㎢</p>
                                                                      </li>
                                                                  </ul>
                                                              </div>
                                                          </li> */}
                                  </ul>
                                </div>
                                {/* //table */}
                              </div>
                            </li>
                          </ul>
                        </div>
                      </li>
                      <li className="divider" />
                      <li>
                        <div className="text">
                          <h1>잘피</h1>
                          <p>
                            잘피는 열대부터 북극 주변까지 전 세계 얕은 바다에서 사는 해양 현화식물이다.
                            전 세계적으로 총 70 여종 이상의 잘피가 있으며, 지구상에서 가장 넓은 연안 서식지를
                            형성한다. 전 세계 잘피 면적은 177,000~600,000㎢로 추정한다.
                          </p>
                        </div>
                        <div className="imgBox">
                          <img src="./images/about/photo10.jpg" />
                        </div>
                      </li>
                      <li className="type2">
                        <div className="dataContainer">
                          <ul>
                            <li>
                              <h1>
                                국가(지역)별 잘피 면적(2003)
                              </h1>
                              <div className="dataBox">
                                {/* table */}
                                <div className="blueCarbonTable">
                                  <ul>
                                    <li>
                                      <div className="blueCarbonTableHead">
                                        호주 동부
                                      </div>
                                      <div className="blueCarbonTableData">
                                        <ul>
                                          <li>
                                            <h1>면적.</h1>
                                            <p>71,371㎢</p>
                                          </li>
                                        </ul>
                                      </div>
                                    </li>
                                    <li>
                                      <div className="blueCarbonTableHead">
                                        인도네시아
                                      </div>
                                      <div className="blueCarbonTableData">
                                        <ul>
                                          <li>
                                            <h1>면적.</h1>
                                            <p>30,000㎢</p>
                                          </li>
                                        </ul>
                                      </div>
                                    </li>
                                    <li>
                                      <div className="blueCarbonTableHead">
                                        호주 서부
                                      </div>
                                      <div className="blueCarbonTableData">
                                        <ul>
                                          <li>
                                            <h1>면적.</h1>
                                            <p>25,000㎢</p>
                                          </li>
                                        </ul>
                                      </div>
                                    </li>
                                    <li>
                                      <div className="blueCarbonTableHead">
                                        멕시코만
                                      </div>
                                      <div className="blueCarbonTableData">
                                        <ul>
                                          <li>
                                            <h1>면적.</h1>
                                            <p>19,349㎢</p>
                                          </li>
                                        </ul>
                                      </div>
                                    </li>
                                    <li>
                                      <div className="blueCarbonTableHead">
                                        지중해 서부
                                      </div>
                                      <div className="blueCarbonTableData">
                                        <ul>
                                          <li>
                                            <h1>면적.</h1>
                                            <p>4,152㎢</p>
                                          </li>
                                        </ul>
                                      </div>
                                    </li>
                                    <li>
                                      <div className="blueCarbonTableHead">
                                        일본
                                      </div>
                                      <div className="blueCarbonTableData">
                                        <ul>
                                          <li>
                                            <h1>면적.</h1>
                                            <p>495㎢</p>
                                          </li>
                                        </ul>
                                      </div>
                                    </li>
                                    <li>
                                      <div className="blueCarbonTableHead">
                                        대한민국
                                      </div>
                                      <div className="blueCarbonTableData">
                                        <ul>
                                          <li>
                                            <h1>면적.</h1>
                                            <p className="pointColor">45㎢</p>
                                          </li>
                                        </ul>
                                      </div>
                                    </li>
                                  </ul>
                                </div>
                                {/* //table */}
                              </div>
                            </li>
                          </ul>
                        </div>
                      </li>
                      <li className="divider" />
                      <li>
                        <div className="text">
                          <h1>갯벌</h1>
                          <p>
                            위성영상(1984~2016년)으로 분석한 전 세계 갯벌 면적은 127,921㎢로 전 세계
                            맹그로브 면적과 유사하다. 총 면적의 약 50%는 아시아, 북아메리카, 남아메리카
                            3개 대륙의 8개 국가에서 분포하며, 인도네시아, 중국, 호주 순으로 넓게 분포한다.
                            1984년~2016년 사이 20,000㎢(약 16%) 이상의 갯벌이 유실됐다.
                          </p>
                        </div>
                        <div className="imgBox">
                          <img src="./images/about/photo11.jpg" />
                        </div>
                      </li>
                      <li className="type2">
                        <div className="dataContainer">
                          <ul>
                            <li>
                              <h1>
                                지역별 갯벌 면적(2014-2016)
                              </h1>
                              <div className="dataBox">
                                {/* table */}
                                <div className="blueCarbonTable">
                                  <ul>
                                    <li>
                                      <div className="blueCarbonTableHead">
                                        인도네시아
                                      </div>
                                      <div className="blueCarbonTableData">
                                        <ul>
                                          <li>
                                            <h1>면적.</h1>
                                            <p>14,416㎢</p>
                                          </li>
                                        </ul>
                                      </div>
                                    </li>
                                    <li>
                                      <div className="blueCarbonTableHead">
                                        중국
                                      </div>
                                      <div className="blueCarbonTableData">
                                        <ul>
                                          <li>
                                            <h1>면적.</h1>
                                            <p>12,049㎢</p>
                                          </li>
                                        </ul>
                                      </div>
                                    </li>
                                    <li>
                                      <div className="blueCarbonTableHead">
                                        호주
                                      </div>
                                      <div className="blueCarbonTableData">
                                        <ul>
                                          <li>
                                            <h1>면적.</h1>
                                            <p>8,866㎢</p>
                                          </li>
                                        </ul>
                                      </div>
                                    </li>
                                    <li>
                                      <div className="blueCarbonTableHead">
                                        미국
                                      </div>
                                      <div className="blueCarbonTableData">
                                        <ul>
                                          <li>
                                            <h1>면적.</h1>
                                            <p>6,622㎢</p>
                                          </li>
                                        </ul>
                                      </div>
                                    </li>
                                    <li>
                                      <div className="blueCarbonTableHead">
                                        캐나다
                                      </div>
                                      <div className="blueCarbonTableData">
                                        <ul>
                                          <li>
                                            <h1>면적.</h1>
                                            <p>6,477㎢</p>
                                          </li>
                                        </ul>
                                      </div>
                                    </li>
                                    <li>
                                      <div className="blueCarbonTableHead">
                                        인도
                                      </div>
                                      <div className="blueCarbonTableData">
                                        <ul>
                                          <li>
                                            <h1>면적.</h1>
                                            <p>5,788㎢</p>
                                          </li>
                                        </ul>
                                      </div>
                                    </li>
                                    <li>
                                      <div className="blueCarbonTableHead">
                                        대한민국
                                      </div>
                                      <div className="blueCarbonTableData">
                                        <ul>
                                          <li>
                                            <h1>면적.</h1>
                                            <p className="pointColor">2,482㎢</p>
                                          </li>
                                        </ul>
                                      </div>
                                    </li>
                                  </ul>
                                </div>
                                {/* //table */}
                              </div>
                            </li>
                          </ul>
                        </div>
                      </li>
                    </ul>
                  </div>
                  {/* //layout2 */}
                </div>
              </div>
              {/* //section5 */}
            </div>
            {/* <Link to="/home">
                <img alt="BlueCarbon" src="./images/BCLogo.svg" />
            </Link> */}
        </>
    )
}

export default About
